import React, { lazy } from 'react';

import { RouteObject } from 'react-router-dom';

const FAQ = lazy(() => import('@pages/landing/FAQ'));

export const FAQRoutes: RouteObject[] = [
  {
    path: '/faq',
    element: (
      <React.Suspense>
        <FAQ />
      </React.Suspense>
    ),
  },
];
